import { createStore } from 'vuex'

export const dataProduct = createStore({
  state: () => {
    return {
      name: undefined,
      amount: undefined,
      description: undefined,
      price: undefined,
      type: undefined
    }
  },
  mutations: {
    reset (state) {
      state.name = undefined
      state.amount = undefined
      state.description = undefined
      state.price = undefined
      state.type = undefined
    },
    updateProductFields (state, payload) {
      Object.assign(state, payload)
    }
  }
})
